import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '../common';
import { formatDistanceToNow } from 'date-fns';

const statusColors = {
  setup: 'bg-yellow-100 text-yellow-800',
  active: 'bg-green-100 text-green-800',
  paused: 'bg-gray-100 text-gray-800',
  completed: 'bg-blue-100 text-blue-800',
  abandoned: 'bg-red-100 text-red-800',
};

export const GameCard = ({ game }) => {
  const navigate = useNavigate();

  return (
    <Card hoverable onClick={() => navigate(`/games/${game.id}`)}>
      <CardBody>
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-lg font-semibold text-gray-900">
            {game.title}
          </h3>
          <span className={`
            px-2 py-1 text-xs font-medium rounded-full uppercase
            ${game.myRole === 'gm' ? 'bg-primary-100 text-primary-800' : 'bg-gray-100 text-gray-600'}
          `}>
            {game.myRole}
          </span>
        </div>

        {game.description && (
          <p className="text-gray-600 text-sm mb-4 line-clamp-2">
            {game.description}
          </p>
        )}

        <div className="flex items-center gap-3 mb-4">
          <span className="text-sm text-gray-500">
            {game.playerUserIds?.length || 0} players
          </span>
          <span className="text-sm text-gray-500">
            Round {game.totalRounds}
          </span>
          <span className={`
            px-2 py-0.5 text-xs font-medium rounded-full uppercase
            ${statusColors[game.status]}
          `}>
            {game.status}
          </span>
        </div>

        <div className="text-xs text-gray-400">
          Updated {formatDistanceToNow(new Date(game.updatedAt), { addSuffix: true })}
        </div>
      </CardBody>
    </Card>
  );
};
